




















































































































































































import { openOttoPay } from '@/utils/ottoPay'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { debounce, get, take } from 'lodash-es'
import { formatNumber, getRequestId, formatCouponText, getEdcMidMapping } from '@/utils/helpers'
import api from '@/api'
import constants from '@/utils/constants'
import countryData from '@/utils/country'
import ConfirmModal from './ConfirmModal.vue'
import CurrencyInput from './CurrencyInput.vue'
import CouponModal from './CouponModal/CouponModal.vue'
import CountrySelector from '@/components/CountrySelector/CountrySelector.vue'
import PosOrderModal from '@/components/PosOrderModal.vue'

@Component({
  components: {
    ConfirmModal,
    CurrencyInput,
    CouponModal,
    CountrySelector,
    PosOrderModal
  },
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    },
  },
})
export default class PosOrderType extends Vue {
  @Prop() showCart!: boolean
  @Prop(Function) hidePosOrder!: Function
  @Prop(Function) reload!: Function
  @Prop(Function) handleClickOrderStatus!: Function
  @Prop(Function) switchOrderType!: Function
  public payment: string = ''
  public customerName: string = ''
  public phoneNumber: string = ''
  public showDetail: boolean = false
  public paymentDetail: any = {}
  public discount_name: string = ''
  public has_processing_fee: number = 1
  public showProcessingFee: boolean = false
  public showSubTotal: boolean = false
  public country: any = countryData[0]
  public validPhone: boolean = true
  public showPaymentChannel: boolean = false
  public options: Array<any> = [
    {
      value: 'QR', // for ottopay
      text: 'EDC - QRIS Payment',
      type: 'edc',
    },
    {
      value: 'DEBITCARD',
      text: 'Debit Card',
      type: 'edc',
    },
    {
      value: 'CREDITCARD',
      text: 'Credit Card',
      type: 'edc',
    },
  ]
  public onlineOptions: Array<any> = []
  public edcOptions: Array<any> = []
  public selectedPayment: object = {}
  public submitLoading: boolean = false
  public orderRequestId: string = ''
  public custom_total_payment: number = 0
  public total_payment: number = 0
  public processing_fee: number = 0
  public total_payemnt: number = 0
  public constants: any = constants
  public payment_method: string = ''
  public debounceCalculate
  public fetchingCoupons: boolean = false
  public coupon: any = {}
  public showCouponModal: boolean = false
  public coupons: Array<any> = []
  public showPosOrderPopup: boolean = false
  public posOrderId: string = ''
  public formatCouponText: Function = formatCouponText
  $swal: any

  setCountry(item) {
    this.country = item;
  }

  created() {
    this.debounceCalculate = debounce(this.calculateOrder, 500)
  }

  calculateOrder() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    if (this.coupon.id && this.phoneNumber && this.total_payment) {
      this.submitLoading = true
      api.BoCalCulateOrder({
        orderType: 'POS',
        orderSource: 'BO',
        payment: [
          {
            paymentAmount: this.total_payment,
          }
        ],
        destinationStore: {
          outletCode: posOrderOutlet.value.toString(),
        },
        requestId: getRequestId(),
        contact: {
          phone: `${this.country.code}-${this.phoneNumber}`
        },
        has_processing_fee: this.has_processing_fee,
        promo_id: this.coupon.id,
        referral_type: this.coupon.referral_type,
        referral_user_type: this.coupon.referral_user_type,
      }).then((res) => {
        const message = (res.data as any).invalidMessage
        if (message !== constants.UPPER_SUCCESS) {
          this.$swal(
            constants.SOMETHING_WROING,
            message,
            constants.STATUS_ERROR
          )
          return
        }
        try {
          const { couponUseResult, orderCalculations } = res.data.data
          if (couponUseResult !== constants.STATUS_SUCCESS) {
            this.$swal(
              constants.SOMETHING_WROING,
              couponUseResult,
              constants.STATUS_ERROR
            )
            this.coupon = {}
            this.paymentDetail = {}
            return
          }
          const paymentDetail: any = {}
          for (let i = 0; i < orderCalculations.length; i++) {
            const element = orderCalculations[i]
            paymentDetail[element.key] = element.value
          }
          this.paymentDetail = paymentDetail
        } catch (error) {}
      }).finally(() => {
        this.submitLoading = false
      })
    } else {
      this.paymentDetail = {}
    }
  }

  @Watch('phoneNumber')
  watchPhoneNumber() {
    if (this.coupon.id) {
      this.coupon = {}
      this.debounceCalculate()
    }
    if (!this.phoneNumber) return (this.validPhone = true)
    if (
      this.country.code === '+62' &&
      (this.phoneNumber.length > 15 ||
        this.phoneNumber.length < 9 ||
        (this.phoneNumber &&
          (take(this.phoneNumber, 2).join('') !== '08' && this.phoneNumber[0] !== '8')))
    ) {
      this.validPhone = false
    } else {
      this.validPhone = true
    }
  }
  @Watch('country.code')
  watchCountry() {
    this.watchPhoneNumber()
  }
  showPaymentChannelHandle() {
    this.showPaymentChannel = true
  }
  hidePaymentChannelHandle() {
    this.showPaymentChannel = false
  }

  showDetailHandle() {
    this.showDetail = !this.showDetail
  }

  @Watch('has_processing_fee')
  watchHasProcessingFee() {
    if (this.has_processing_fee === 0) {
      this.custom_total_payment = this.total_payment
      this.showProcessingFee = false
    } else {
      if (this.total_payment > 0) {
        this.showProcessingFee = true
        this.custom_total_payment = this.total_payment + this.processing_fee
      }
    }
    this.debounceCalculate()
  }

  changePayment(e) {
    this.selectedPayment = this.options.filter((item) => item.value === e)[0]
    this.payment = e
    this.hidePaymentChannelHandle()
  }

  mounted() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    const { is_pos_input, payment_method, processing_fee } = outletData
    this.payment_method = payment_method
    if (is_pos_input === 1) {
      if (payment_method === 'Midtrans') {
        this.options.unshift(
          {
            value: 'Qris-GoPay',
            text: 'QRIS - Gopay',
            type: 'online',
          },
          {
            value: 'Qris-ShopeePay',
            text: 'QRIS - Shopee pay',
            type: 'online',
          }
        )
      } else if (payment_method === 'Astrapay') {
        this.options.unshift({
          value: 'Astrapay',
          text: 'QRIS - AstraPay',
          type: 'online'
        })
      } else {
        this.options.unshift({
          value: 'QRPay',
          text: 'QRIS - CIMB',
          type: 'online',
        })
      }
    }

    this.onlineOptions = this.options.filter((item) => item.type === 'online')
    this.edcOptions = this.options.filter((item) => item.type === 'edc')

    this.processing_fee = get(processing_fee, 'POS', 0)
  }

  submitHandle() {
    if (this.submitLoading) {
      return
    }
    sessionStorage.removeItem('isPos')
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}');
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    this.submitLoading = true
    const MerchantName = localStorage.getItem('UserName')
    const paymentAmount = Number(this.total_payment || 0)
    const orderPayload: any = {
      userId: constants.DEFAULT_USER_ID,
      orderType: 'POS',
      orderSource: 'BO',
      TableNo: '',
      promo_value: 0,
      custom_total_payment: paymentAmount,
      discount_name: '',
      payment: [
        {
          paymentAmount,
          paymentUsed: 0,
          paymentMethodCode: this.payment,
        },
      ],
      destinationStore: { outletCode: String(posOrderOutlet.value) },
      orderLines: [],
      requestId: this.orderRequestId || (this.orderRequestId = getRequestId()),
      user: {
        qravedUserID: constants.DEFAULT_USER_ID,
        name: this.customerName || MerchantName,
        phoneNo: this.country.code + '-' + (this.phoneNumber || '0888888888'),
        id: constants.DEFAULT_USER_ID,
      },
      notes: '',
      contact: {
        phone: this.country.code + '-' + (this.phoneNumber || '0888888888'),
        name: this.customerName || MerchantName,
      },
      posOrderId: this.posOrderId || undefined,
      has_processing_fee: this.has_processing_fee,
      promo_id: this.coupon && this.coupon.id ? this.coupon.id : undefined,
      referral_code: this.coupon && this.coupon.referral_code ? this.coupon.referral_code : undefined,
      referral_type: this.coupon && this.coupon.referral_type ? this.coupon.referral_type : undefined,
      referral_user_type: this.coupon && this.coupon.referral_user_type ? this.coupon.referral_user_type : undefined,
      commission: this.coupon && this.coupon.commission ? this.coupon.commission : undefined,
      referral_campaign_id: this.coupon && this.coupon.referral_campaign_id ? this.coupon.referral_campaign_id : undefined,
    }
    api
      .BoPosOrder(orderPayload)
      .then((res) => {
        this.submitLoading = false
        if (res.data.code !== constants.STATUS_200_STRING) {
          this.orderRequestId = ''
          if (res.data.message === constants.FAILED_COUPON) {
            this.coupon = {}
            this.paymentDetail = {}
          }
          return this.$swal(
            constants.SOMETHING_WROING,
            res.data.message,
            constants.STATUS_ERROR
          )
        }
        if (res.data.invalidMessage !== constants.UPPER_SUCCESS) {
          this.orderRequestId = ''
          return this.$swal(
            constants.SOMETHING_WROING,
            res.data.invalidMessage,
            constants.STATUS_ERROR
          )
        }
        const data = res.data.data
        if (openOttoPay(this, data)) return

        if (data.paymentSuccess) {
          this.orderRequestId = ''
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem('cartListInfo', JSON.stringify({
            isFree: true,
            selectedPayment: {
              text: 'Free'
            },
            posOrderInput: {
              active: outletData.pos_active,
              posName: outletData.pos_name,
              mandatory: outletData.pos_order_required
            }
          }))

          sessionStorage.setItem('orderId', data.orderId)
          this.$router.push('/pos-result')
          return
        }

        let qrCode = ''
        if (constants.QR_TYPE.includes(this.payment)) {
          qrCode =
            this.payment_method === 'Midtrans'
              ? data.qrData.qr_string
              : data.qrData.data.qrCode
        }

        if (qrCode) {
          this.orderRequestId = ''
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem('orderId', data.orderId)
          sessionStorage.setItem('qrCode', qrCode)
          sessionStorage.setItem(
            'cartListInfo',
            JSON.stringify({
              cartList: [],
              promo_value: 0,
              promo_type: 0,
              has_service_fee: 0,
              has_tax: 0,
              discount_name: 0,
              payment_method: this.payment_method,
              payment: this.payment,
              phoneNumber: this.phoneNumber,
              country: this.country,
              customerName: this.customerName || MerchantName,
              totalSales: data.totalSales,
              notes: '',
              selectedPayment: this.selectedPayment,
              posOrderInput: {
                active: outletData.pos_active,
                posName: outletData.pos_name,
                mandatory: outletData.pos_order_required
              }
            })
          )
          sessionStorage.setItem('isPos', '1')
          sessionStorage.removeItem('leftTime')
          this.$router.push(`/pos-qr`)
          return
        }
        if (window && typeof (window as any).android !== 'undefined') {
          ;(window as any).android.payAtCashier(
            res.data.data.orderId,
            this.payment,
            data.totalSales,
            getEdcMidMapping()
          )
        }
      })
      .catch((err) => {
        this.orderRequestId = ''
        this.$swal(
          constants.SOMETHING_WROING,
          err.response.data.message,
          constants.STATUS_ERROR
        )
        this.submitLoading = false
        console.log(err)
        throw err
      })
  }
  changeCustomTotalPayment(event) {
    if (Number(event) === this.total_payment) {
      return
    }
    if (isNaN(event) || Number(event) < 0) {
      return (this.total_payment = 0)
    }
    this.total_payment = Number(event || 0)
    if (this.total_payment > 0) {
      this.showSubTotal = true
      if (this.has_processing_fee === 1) {
        this.custom_total_payment = this.total_payment + this.processing_fee
        this.showProcessingFee = true
      } else {
        this.showProcessingFee = false
        this.custom_total_payment = this.total_payment
      }
    } else {
      this.showSubTotal = false
      this.showProcessingFee = false
      this.custom_total_payment = 0
    }
    this.debounceCalculate()
  }
  confirmPayment() {
    this.reload()
    this.hidePosOrder()
  }

  async getCoupons() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    this.fetchingCoupons = true
    api
      .GetStoreCoupons(posOrderOutlet.value, 'POS', `${this.country.code}-${this.phoneNumber}`)
      .then((res: any) => {
        if (res.data && res.data.status === 200) {
          this.coupons = res.data.result
        } else {
          this.coupons = []
        }
      })
      .catch(() => {
        this.coupons = []
      })
      .finally(() => {
        this.fetchingCoupons = false
      })
  }
  showCouponModalHandle() {
    this.showCouponModal = true
    this.coupons = []
    this.getCoupons()
  }
  setCouponHandle(item) {
    this.showCouponModal = false
    if (item.id === this.coupon.id) {
      this.coupon = item
      return
    }
    this.coupon = item
    this.debounceCalculate()
  }
  hideCouponHandle() {
    this.showCouponModal = false
  }

  checkOrderSubmit() {
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    if (outletData.pos_active === 1 && outletData.pos_order_required === 1) {
      this.showPosOrderPopup = true
    } else {
      this.submitHandle()
    }
  }

  posOrderPopup(value) {
    this.showPosOrderPopup = value
  }
  posOrderValue(value) {
    this.posOrderId = value
    this.submitHandle()
  }
}
